import { PillarsMenu } from '@/models/channels'

export default () => ({
  menuState: PillarsMenu.CLOSED,
  menuTab: undefined
})
